import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { useLocale } from '@frontend/lang';
import { ProductClient } from '@frontend/product/api';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { IProduct, ProductQueryParams } from '@frontend/product/types';
import React, { useState } from 'react';

const ID = 'product-select';
export interface ProductSelectProps extends ObjectSelectV2Props<IProduct, ProductQueryParams> {}
/**
* @deprecated
*/
export const ProductSelect = (props: ProductSelectProps) => {
    const { locale } = useLocale();
    const [v, cV] = useState<IProduct | null>(null);
    return (
        <ObjectSelectInputV2<IProduct, ProductQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            key={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Product'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={v}
            searchValueOverwrite={props.searchValueOverwrite}
            isClearable={props.isClearable}
            idValue={props.isClearable ? props.value : props.value || v?.id}
            fetch={(arg) => ProductClient.fetchProducts({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(prod: IProduct) => defaultMapWithAttributes(prod, locale)}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            subset={props.subset}
            isOpenOverwrite={props.isOpenOverwrite}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'product_id',
                          fetch: (id) =>
                              ProductClient.resolveProducts([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
